<template>
  <slot
      :sample="VueCsvImportData.firstSampleRow"
      :map="VueCsvImportData.map"
      :fields="VueCsvImportData.fields"
  >
      <template v-if="VueCsvImportData.firstSampleRow">
          <table v-bind="tableAttributes">
            <thead>
              <tr>
                <td v-for="(field, key) in headers" :key="field">
                  {{ field }}
                  <select
                    v-model="csvMap[key]"
                    :name="`csv_uploader_map_${key}`"
                    required
                  >
                  <option value>{{ labels.excludeField }}</option>
                    <option
                        v-for="option in availableFields"
                        :value="option.label"
                        :key="option.key"
                        :disabled="option.selected"
                    >
                          {{ option.label }}{{ option.required ? labels.requiredField : ''}}
                    </option>
                    <option
                        v-if="!VueCsvImportData.fields.map(f => f.label).includes(field)"
                        :value="field"
                        :key="field"
                    >
                          {{ field }}
                    </option>
                  </select>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in csvSample" :key="rowIndex">
                <td v-for="(item, itemIndex) in row" :key="itemIndex">{{item}}</td>
              </tr>
            </tbody>
          </table>
      </template>
  </slot>
</template>

<script>
import {
  computed, inject, watch, reactive,
} from 'vue';

export default {
  name: 'CsvTableMap',
  props: {
    tableAttributes: {
      type: Object,
      default() {
        return {};
      },
    },
    autoMatch: {
      type: Boolean,
      default: true,
    },
    autoMatchIgnoreCase: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const VueCsvImportData = inject('VueCsvImportData');
    const buildMappedCsv = inject('buildMappedCsv');
    const labels = VueCsvImportData.language;
    const csvMap = reactive({});

    const availableFields = computed(() => VueCsvImportData.fields.map((f) => {
      f.selected = Object.values(csvMap).includes(f.label);
      return f;
    }));

    watch(() => csvMap, () => {
      VueCsvImportData.map = {};
      Object.entries(csvMap)
        .filter(([, value]) => value !== '')
        .forEach(([key, value]) => {
          VueCsvImportData.map[value.toLowerCase()] = key;
        });

      if (VueCsvImportData.allFieldsAreMapped) {
        buildMappedCsv();
      }
    }, { deep: true });

    const csvSample = computed(() => (VueCsvImportData.fileHasHeaders ? VueCsvImportData.csvSample : VueCsvImportData.csvSample.slice(1)));

    const headers = computed(() => {
      if (VueCsvImportData.fileHasHeaders) {
        return [...Array(VueCsvImportData.firstSampleRow.length).keys()].map((i) => `${labels.csvColumn} ${i}`);
      }
      return VueCsvImportData.firstSampleRow;
    });

    if (props.autoMatch) {
      watch(() => VueCsvImportData.csvSample, (newVal) => {
        if (newVal) {
          VueCsvImportData.fields.forEach((field) => {
            newVal[0].forEach((columnName, index) => {
              const fieldName = props.autoMatchIgnoreCase ? field.label.toLowerCase().trim() : field.label.trim();
              const colName = props.autoMatchIgnoreCase ? columnName.toLowerCase().trim() : columnName.trim();
              if (fieldName === colName) {
                csvMap[index] = field.label;
              }
            });
          });
        }
      });
    }

    return {
      availableFields,
      csvMap,
      csvSample,
      headers,
      VueCsvImportData,
      labels,
    };
  },
};
</script>
